/**
 * useMyCampaign — the campaign the signed-in user can still use, or null.
 * Placement: frontend/src/hooks/useMyCampaign.ts
 * Pass enabled=false where a campaign can never apply (e.g. an existing paid
 * subscription) to skip the request.
 */
import { useEffect, useState } from 'react';
import apiService from '../services/api';
import type { PromoCampaign } from '../utils/promoPricing';

export function useMyCampaign(enabled: boolean = true): PromoCampaign | null {
  const [campaign, setCampaign] = useState<PromoCampaign | null>(null);
  useEffect(() => {
    if (!enabled) { setCampaign(null); return; }
    let alive = true;
    apiService
      .get('/promotions/me')
      .then((r: any) => { if (alive) setCampaign(r?.data?.campaign || null); })
      .catch(() => { if (alive) setCampaign(null); });
    return () => { alive = false; };
  }, [enabled]);
  return campaign;
}

export default useMyCampaign;
